import React from 'react';
import { Trans, useTranslator } from 'tradera/lang/translate';
import { Heading } from '../../common/form/form-parts';
import {
    getAcceptsMarketing,
    setAcceptsMarketing
} from 'tradera/apps/registration/helpers/blueshift';
import BankIdIcon from '@tradera/blueprint/theme/icons2/bankid.svg?jsx';
import { Input, InputCheckbox } from './form-input';
import { useFormContext } from 'react-hook-form';
import formatPersonalId from '../format-personal-id';
import { Button } from 'tradera/components/atoms/button/button';
import { mapTermsUrl } from 'tradera/utils/map-terms-url';
import { FormError } from 'tradera/apps/registration/components/common/form/form-error';

export const SwedishCompanyFormConfirm = ({
    rules,
    serverErrors,
    moneyTransferLicenseAgreementName
}) => {
    const { t } = useTranslator();
    const { register, getValues, setValue } = useFormContext();

    const handleClick = () => {
        const formattedSsn = formatPersonalId(getValues('contactSsn'));
        setValue('contactSsn', formattedSsn);
        setValue(
            'moneyTransferLicenseAgreementName',
            moneyTransferLicenseAgreementName
        );
    };

    const errorList = Object.keys(serverErrors);

    return (
        <>
            <Heading className="mb-7">
                {t('registration_confirm_identity')}
            </Heading>
            <p className="mb-3">
                {t('registration_confirm_identity_nonsignatory')}
            </p>
            <div className="d-flex w-100 mb-1">
                <Input
                    name="contactFirstName"
                    type="text"
                    className="mr-1"
                    label={t('registration_placeholder_first_name')}
                    rules={rules}
                    serverErrors={serverErrors}
                />
                <Input
                    name="contactLastName"
                    type="text"
                    label={t('registration_placeholder_last_name')}
                    rules={rules}
                    serverErrors={serverErrors}
                />
            </div>

            <Input
                name="contactSsn"
                type="tel"
                className="mb-3"
                label={t('registration_placeholder_ssn')}
                rules={rules}
                serverErrors={serverErrors}
            />

            <InputCheckbox
                name="terms"
                type="checkbox"
                rules={rules}
                serverErrors={serverErrors}>
                <Trans
                    i18nKey="registration_company_terms_conditions_and_payment_Trans"
                    components={{
                        a: (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link"
                            />
                        ),
                        termsLink: (
                            <Button
                                theme="link"
                                target="_blank"
                                href={mapTermsUrl(
                                    moneyTransferLicenseAgreementName,
                                    t
                                )}
                            />
                        )
                    }}
                />
            </InputCheckbox>
            <div className="mb-1">
                <div className="form-check form-check-sm align-items-center">
                    <input
                        id="marketing"
                        name="marketing"
                        type="checkbox"
                        className={`form-check-input position-relative mr-1`}
                        onChange={(e) => setAcceptsMarketing(e.target.checked)}
                        defaultChecked={getAcceptsMarketing()}
                        {...register('marketing')}
                    />
                    <label htmlFor="marketing" className="mb-0 size-oslo">
                        {t('registration_marketing_label')}
                    </label>
                </div>
            </div>
            <div className="mb-1">
                <button
                    type="submit"
                    className="btn btn-primary btn-fluid btn--icon-fixed mt-1 mb-4 mr-4"
                    onClick={handleClick}>
                    <BankIdIcon className="icon icon-sm icon-before" />
                    {t('registration_confirm_with_bank_id')}
                </button>
            </div>
            {errorList?.length > 0 && (
                <div className="mt-3 mb-1">
                    <p className="text-danger mb-1">
                        {t('registration_submit_error_message')}
                    </p>
                    {errorList.map((error) => (
                        <FormError
                            key={error}
                            serverErrors={serverErrors}
                            name={error}
                        />
                    ))}
                </div>
            )}
        </>
    );
};
